var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isMobileOnly } from 'react-device-detect';
import { NON_DIGITS_REGEX } from '../constants/regex';
import { allowanceStatus, } from '../models/proallowance';
export var isSsr = typeof window === 'undefined';
export var getHost = function () {
    if (isSsr)
        return '';
    if (process.env.NODE_ENV === 'production' && !process.env.DOMAIN_NAME) {
        return "https://".concat(window.location.hostname);
    }
    return window.location.origin;
};
export var getChannelID = function () { return (isMobileOnly ? 2 : 1); };
export var generateXB3TraceID = function () {
    return Math.random().toString(16).substring(2) +
        new Date().getTime().toString(16).substring(0, 15);
};
export var removeNonDigitsFromString = function (string) {
    if (string === void 0) { string = ''; }
    return string.replace(NON_DIGITS_REGEX, '');
};
export var getTmxId = function () {
    var _a, _b, _c;
    var nativeTMXID = '';
    if ((_a = window.__EXPERIENCE_CONTEXT__) === null || _a === void 0 ? void 0 : _a.isConsumerApp) {
        nativeTMXID = getUrlParam('guid');
    }
    return nativeTMXID || ((_c = (_b = window.THD_ACCOUNT_LIB) === null || _b === void 0 ? void 0 : _b.TMX) === null || _c === void 0 ? void 0 : _c.getTMXsessionId());
};
export var getUrlParam = function (key) {
    var _a;
    var searchParams = typeof window !== 'undefined' ? (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.search : '';
    var urlParams = new URLSearchParams(searchParams);
    return urlParams.get(key);
};
export var scrollToTop = function () {
    window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
    });
};
export var getSiteKey = function (isB2B) {
    if (window.location.hostname.endsWith('homedepot.com')) {
        return isB2B
            ? '6LfEHBkTAAAAAHX6YgeUw9x1Sutr7EzhMdpbIfWJ'
            : '6LcAvCkaAAAAANWymwFQVvpFDQIBDCI4NbAvXGJL';
    }
    return '6Le3GRkTAAAAAPpXON0jcJCLrYZnm-ZqyLhbCLbX';
};
export var getConfigurationValue = function (value) {
    var _a;
    return typeof window !== 'undefined'
        ? (_a = window.__EXPERIENCE_PROPS__) === null || _a === void 0 ? void 0 : _a.expConfiguration[value]
        : '';
};
export var sortByLastAndFirstName = function (userA, userB) {
    var aLastName = userA.lastName.toUpperCase();
    var bLastName = userB.lastName.toUpperCase();
    if (aLastName < bLastName) {
        return -1;
    }
    if (aLastName > bLastName) {
        return 1;
    }
    var aFirstName = userA.firstName.toUpperCase();
    var bFirstName = userB.firstName.toUpperCase();
    if (aFirstName < bFirstName) {
        return -1;
    }
    if (aFirstName > bFirstName) {
        return 1;
    }
    return 0;
};
export var getUsersWithActiveAllowances = function (allowances) {
    var usersWithAllowances = new Map();
    allowances === null || allowances === void 0 ? void 0 : allowances.filter(function (allowance) { return allowance.status === allowanceStatus.ACTIVE; }).forEach(function (allowance) {
        usersWithAllowances.set(allowance.userId, allowance.allowanceId);
    });
    return usersWithAllowances;
};
export var setHasActiveAllowance = function (shoppers, usersWithAllowances) {
    var notAssignedUsers = [];
    var assignedUsers = [];
    shoppers.forEach(function (user) {
        if (usersWithAllowances.get(user.userId)) {
            assignedUsers.push(__assign(__assign({}, user), { hasActAllowance: true }));
        }
        else {
            notAssignedUsers.push(__assign(__assign({}, user), { hasActAllowance: false }));
        }
    });
    return [notAssignedUsers, assignedUsers];
};
